import { Html, Tube } from "@react-three/drei";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "../../design_system/StyledComponents/components/Typography";
import "./FirstTimePopup.css";
import { setShowTutorialPopup } from "../../Actions/PopupAction";
import { popupData } from "./TutorialData";
import { Button } from "../../design_system/StyledComponents/components/Button";
import { Close } from "@mui/icons-material";

const TutorialPopup = () => {
  const { showTutorialPopup, tutorialCustomisedPosition, tutorialPopupNumber, tutorialPopupDismissable } =
    useSelector((state) => state.PopupState);
  const [fadeIn, setFadeIn] = useState(false);
  const [timeLeft, setTimeLeft] = useState(11); // 10 seconds countdown
  const [progress, setProgress] = useState(0);
  const [showClose, setSetShowClose] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showTutorialPopup) {
      setFadeIn(true);
    }
  }, [showTutorialPopup, tutorialPopupNumber]);

  useEffect(()=>{
    if(fadeIn){
      setTimeLeft(11);
      setProgress(0);
      setSetShowClose(false);
    }
  },[tutorialPopupNumber])

  useEffect(() => {
    if (timeLeft === 0 && fadeIn && tutorialPopupDismissable) {
      setSetShowClose(true);
    }

    const timerId = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
      setProgress((prev) => prev + 10);
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft]);

  const handleClose = (e) =>{
    e.stopPropagation();
    dispatch(setShowTutorialPopup({
      showTutorialPopup: false,
      tutorialPopupType: "",
      tutorialCustomisedPosition: null,
      tutorialPopupDismissable: false
    }))
  }

  const handleClick1 = (e) => {
      e.stopPropagation();
      setFadeIn(false);
      const type = popupData[tutorialPopupNumber + 1]?.className? "ui" : "canvas";
      dispatch(setShowTutorialPopup({
          showTutorialPopup: true,
          tutorialPopupType: type,
          tutorialPopupNumber: tutorialPopupNumber + 1,
          tutorialPopupDismissable: false
      }))
  }


  if (tutorialPopupNumber < 0 || tutorialPopupNumber > 9) return null;

  return fadeIn ? (
    <Html position={popupData[tutorialPopupNumber].position === "customised"? tutorialCustomisedPosition :popupData[tutorialPopupNumber].position}>
      <div className={"first-time-popup" + (popupData[tutorialPopupNumber].showArrow ? " " + popupData[tutorialPopupNumber].showArrow : " bottom")}>
        <div className="first-time-popup-container">
        {showClose && (
          <div className="first-time-popup-close">
            <Close
              style={{ cursor: "pointer", color: "white" }}
              onClick={handleClose}
            />
          </div>
        )}
          <div className="first-time-popup-header">
            <Typography modifiers={["header6"]}>
              {popupData[tutorialPopupNumber].title}
            </Typography>
          </div>
          <div className="first-time-popup-body">
            <Typography modifiers={["subtitle"]}>
              {popupData[tutorialPopupNumber]?.description ? popupData[tutorialPopupNumber].description : null}
            </Typography>
          </div>
          <div className="first-time-popup-footer">
            <div className="first-time-popup-footer-order">
              {popupData[tutorialPopupNumber]?.order ? (
              <Typography modifiers={["subtitle2", "white"]}>{popupData[tutorialPopupNumber]?.order}</Typography>
            ) : null}
            </div>
            <div className="first-time-popup-footer-button">
            {popupData[tutorialPopupNumber]?.buttonText1 ? (
              <Button
                className="first-time-popup-button"
                modifiers={["white", "small"]}
                onClick={handleClick1}
              >
                <Typography modifiers={["subtitle2","medium"]}>{popupData[tutorialPopupNumber].buttonText1}</Typography>
              </Button>
            ) : null}
            </div>
          </div>
          {!showClose && tutorialPopupDismissable && <div className="timer-container">
            <div className="timer-progress" style={{ width: `${progress}%` }} />
          </div>}
        </div>
      </div>
    </Html>
  ) : null;
};

export default TutorialPopup;
